import { useState, useEffect, useRef } from 'react';

export default function UpdateBanner() {
  const [visible, setVisible] = useState(false);
  const workerRef = useRef(null);

  useEffect(() => {
    // Rattrape une mise à jour déjà détectée avant le montage de ce composant
    // (course possible entre le chargement du service worker et React).
    if (window.__pendingSwUpdate) {
      workerRef.current = window.__pendingSwUpdate;
      setVisible(true);
    }
    const handler = (e) => {
      workerRef.current = e.detail.worker;
      setVisible(true);
    };
    window.addEventListener('sw-update-available', handler);
    return () => window.removeEventListener('sw-update-available', handler);
  }, []);

  if (!visible) return null;

  const handleUpdate = () => {
    if (workerRef.current) {
      workerRef.current.postMessage({ type: 'SKIP_WAITING' });
    }
    setVisible(false);
  };

  return (
    <div style={{
      position: 'fixed', left: 0, right: 0, bottom: 0, zIndex: 1000,
      display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 14,
      padding: '12px 16px', background: '#1e293b', color: '#f8fafc',
      boxShadow: '0 -4px 16px rgba(0,0,0,.15)', flexWrap: 'wrap',
    }}>
      <span style={{ fontSize: '0.9rem', fontWeight: 600 }}>
        Une nouvelle version est disponible.
      </span>
      <button onClick={handleUpdate} style={{
        background: '#22c55e', color: '#fff', border: 'none', borderRadius: 8,
        padding: '8px 18px', fontWeight: 700, fontSize: '0.88rem', cursor: 'pointer',
      }}>
        Actualiser
      </button>
    </div>
  );
}
